define([
	"dojo/_base/declare",
	"csi/heading/String"
], function(declare,String) {

	return declare(String, {
		bBaseRenderer: true,

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported
			return null;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: apply any renderer-specific changes to context before use
			var	act = ctx.getNode();
			var cal = ctx.view.getViewNode();

			// handle special case where context is milestone activity
			if (cal.$Type == "Milestone") {
				cal = ctx.cache.getNode(cal.__Parent__);
			}

			var rollup = ctx.cache.getNode(cal.CalendarRollup);
			ctx.pushParams().setNode(rollup);
			ctx.keyValue = act.Index;
			ctx.setReadOnly(false);
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context applied above
			ctx.keyValue = null;
			ctx.pop();
			this.inherited(arguments);
		}
	});
});